'use client'

import Image from 'next/image'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import NabooLogo from '../../atoms/logos/NabooLogo'

const Maintenance = () => {
  return (
    <div className='h-full'>
      <div className='absolute p-4'>
        <NabooLogo />
      </div>
      <div className='flex h-full flex-col items-center justify-center'>
        <div className='text-center'>
          <h1>
            <FormattedMessage
              id='ui.Maintenance.websiteAtMaintenance'
              defaultMessage='Le site est en cours de maintenance'
            />
          </h1>
          <p>
            <FormattedMessage
              id='ui.Maintenance.apologizeForTheInconvenience'
              defaultMessage='Veuillez nous excuser pour le désagrément'
            />
          </p>
        </div>
        <div className='mt-8 flex justify-center'>
          <Image
            src='/images/tiago_with_tool.png'
            width={400}
            height={400}
            alt='Tiago with a screwdriver'
            className='object-contain'
          />
        </div>
      </div>
    </div>
  )
}

export default Maintenance
